import { Anchor, Box, ResponsiveContext } from "grommet";
import CenteredColumn from "../components/CenteredColumn";
import PageHeader from "../components/PageHeader";
import { useContext } from "react";
import styled from "styled-components";
import AppContext from "../stateManager/appContext";
import { PortableText } from "@portabletext/react";

const StyledBox = styled(Box)`
  p {
    padding: 0.5rem;
  }
  a {
    color: rgb(116, 114, 100);
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
  }
`;

const CommunityPage = () => {
  const viewportSize = useContext(ResponsiveContext);
  const { siteData } = useContext(AppContext);
  if (!siteData) {
    return null;
  }

  const EventRow = ({ event }) => {
    console.debug("EventRow", event);
    return (
      <Box
        direction={
          viewportSize === "small"
            ? "column-reverse"
            : event.imageLocation === "left"
            ? "row"
            : "row-reverse"
        }
        justify="center"
        gap="medium"
      >
        {event.eventImageUrl && (
          <Box
            width={{ min: "medium" }}
            height={"medium"}
            alignSelf="center"
            round="small"
            background={{
              image: "url(" + event.eventImageUrl + ")",
              position: "center",
            }}
          ></Box>
        )}
        <StyledBox>
          <h4>{event.title}</h4>
          <PortableText value={event.EventDetails} />
        </StyledBox>
      </Box>
    );
  };

  const visibleEvents = siteData.communityEvents.filter(
    (event) => !event.excludeFromWebsite
  );

  return (
    <Box>
      <PageHeader label={siteData.communityPage.title} />
      <CenteredColumn columnWidth="xlarge" pad={{ vertical: "large" }}>
        <Box gap={"small"}>
          {visibleEvents.length === 0 ? (
            <>No community events at this time. </>
          ) : (
            visibleEvents.map((event) => (
              <EventRow event={event} key={event._id} />
            ))
          )}
        </Box>
      </CenteredColumn>
    </Box>
  );
};
export default CommunityPage;
